import { Component, Prop, Watch } from "vue-property-decorator";
import axios, { AxiosPromise } from "axios";
import eventHub from "../../eventHub";
import { ShoppingCartModel, CartProductModel } from "@/models/shoppingCartModel";
import { sisasListiniModel } from "@/models/sisasPimListiniModel";
import baseUserContextProductComponent from "../baseUserContextProductComponent";
import { umDefinition } from "@/models/umDefinition";
import { mapMutations } from "vuex";
@Component({})
export default class offerProductRow extends baseUserContextProductComponent {
    @Prop({ default: () => null })
    productId: number;
    @Prop({ default: () => false })
    readonly: boolean;
    @Prop({ default: () => false })
    showPriceDetails: boolean;
    isInEditQuantity: boolean = false;
    isSendingQuantity: boolean = false;
    isSendingDelete: boolean = false;
    showWarningQuantity: boolean = false;

    isAddingProduct: boolean = false;

    @Prop({ default: 1 })
    quantity: number;

    @Prop({ default: false })
    isLoading: boolean;
    @Prop({ default: false })
    isLoadingListini: boolean;
    @Prop({ default: false })
    showMostraOriginale: boolean;

    // @Prop({ default: () => new productModel() })
    @Prop({ default: () => null })
    items: CartProductModel[];
    myQuantity: number | null = 1;
    @Prop({ default: null })
    note: string | null;

    // arrows + Backspace
    allowKeyCodes = [37, 38, 39, 40, 8];
    allowKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    onKeyDown($event: KeyboardEvent) {
        if (this.allowKeyCodes.indexOf($event.keyCode) == -1 && this.allowKeys.indexOf($event.key) == -1) {
            $event.preventDefault();
        }
    }

    get totalForPice() {
        var instance = this;
        if (instance.myQuantity == null || instance.myQuantity == 0) return 0;

        let total = instance.total;
        if (total == null || total == 0) return 0;
        return total / instance.myQuantity;
    }
    get total() {
        var instance = this;
        if (instance.myQuantity == null || instance.myQuantity == 0) return 0;

        let total = 0;
        if (instance.items && instance.items.length) {
            instance.items.forEach(
                (d) => (total += (d.rowTotal|| 0))
            );
        }
        return total;
    }

    getQuantitaUM(um: string) {
        return this.myQuantity;
    }
    created() {
        this.myQuantity = this.quantity;
    }
    beforeMount() {}

    mounted() {
        var instance = this;
        // this.setQuantity();
    }

    setEditQuantity() {
        this.isInEditQuantity = true;
        this.$emit("edit", this.isInEditQuantity);
    }
    canelEditQuantity() {
        this.isInEditQuantity = false;
        // this.quantity = this.product.quantity * this.proporzione;
        this.myQuantity = this.quantity;
        this.$emit("edit", this.isInEditQuantity);
        this.showWarningQuantity = false;
    }
}
